module.exports = __webpack_public_path__ + "img/How-to-get-HD-TV-Outdoors.11f6c697.jpg";